// src/pages/Users/Galleries/components/AlbumsToolbar.jsx
import React from "react";
import { FaPlus, FaShareAlt, FaTimes, FaEye } from "react-icons/fa";

export default function AlbumsToolbar({
  ui,
  onChange,
  debouncedQ,
  setDebouncedQ,
  isManager,
  onCreate,
}) {
  return (
    <div className="flex flex-col gap-3">
      {/* Recherche + actions */}
      <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
        <input
          type="text"
          placeholder="Rechercher un album (titre, description)…"
          className="input input-bordered w-full dark:bg-slate-200 dark:text-black"
          value={debouncedQ}
          onChange={(e) => setDebouncedQ(e.target.value)}
        />

        <div className="flex items-center gap-2">
          {isManager && (
            <button
              type="button"
              onClick={onCreate}
              title="Créer un album"
              aria-label="Créer un album"
              className="w-10 h-10 grid place-items-center rounded-xl ring-1 transition transform
                         bg-slate-100 ring-slate-200 text-slate-700
                         dark:bg-slate-800 dark:ring-slate-700 dark:text-slate-200
                         hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-violet-400"
            >
              <FaPlus className="text-lg" />
            </button>
          )}

          {isManager && (
            <button
              type="button"
              onClick={() => onChange({ showAll: !ui.showAll })}
              title={ui.showAll ? "Afficher uniquement les albums actifs" : "Afficher tous les albums"}
              aria-label="Afficher tous/actifs"
              className={`w-10 h-10 grid place-items-center rounded-xl ring-1 transition transform
                focus:outline-none focus:ring-2 focus:ring-violet-400 hover:scale-105 active:scale-95
                ${ui.showAll
                  ? "bg-emerald-50 ring-emerald-200 text-emerald-600 dark:bg-emerald-900/20 dark:ring-emerald-800"
                  : "bg-slate-100 ring-slate-200 text-slate-500 dark:bg-slate-800 dark:ring-slate-700"}`}
            >
              <FaEye className="text-lg" />
            </button>
          )}

          <button
            type="button"
            onClick={() => onChange({ q: "", sort: "recent", showAll: isManager ? false : ui.showAll })}
            title="Réinitialiser"
            aria-label="Reset"
            className="w-10 h-10 grid place-items-center rounded-xl ring-1 transition transform
                       bg-slate-100 ring-slate-200 text-slate-500 dark:bg-slate-800 dark:ring-slate-700
                       hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-violet-400"
          >
            <FaTimes className="text-lg" />
          </button>
        </div>
      </div>

      {/* Tri */}
      <div className="flex items-center gap-3">
        <label className="text-sm text-slate-600 dark:text-slate-300">Trier par :</label>
        <select
          className="select select-bordered w-56 dark:bg-slate-200 dark:text-black"
          value={ui.sort}
          onChange={(e) => onChange({ sort: e.target.value })}
        >
          <option value="recent">Plus récents</option>
          <option value="oldest">Plus anciens</option>
          <option value="alpha">Titre (A→Z)</option>
        </select>
      </div>
    </div>
  );
}
